import React from 'react';

export default function Intro() {
  const stats = [
    { number: '1993', label: 'Established' },
    { number: 'FIGURES', label: 'you can trust in' },
    { number: '100%', label: 'Client Focused' },
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#059669]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <span className="inline-block text-[#059669] text-sm font-semibold tracking-widest uppercase mb-4">Our Story</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'EB Garamond', 'Times New Roman', serif" }}>
            Clear, Reliable Financial Support <br className="hidden md:block" />Since 1993
          </h2>
          <p className="text-base text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Butler Professional Services helps organizations maintain clean books, understand their numbers, and make confident financial decisions. With decades of hands‑on experience and advanced training in finance, risk management, and nonprofit stewardship, we deliver practical guidance—not just reports.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-8 rounded-lg bg-gradient-to-b from-[#612c42]/5 to-transparent border border-[#612c42]/10">
              <div className="text-4xl font-bold text-[#612c42] mb-2" style={{ fontFamily: "'EB Garamond', serif" }}>{stat.number}</div>
              <div className="text-sm text-gray-500 font-medium tracking-wide uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}